import { GET_FILTERED_EQUIPAMENTOS, KEY } from '../../Graphql/QUERIES';
import { useEffect, useState } from "react";
import { useEquipment } from "../../hooks/useEquipment";
import EquipmentIndex from "../EquipmentIndex";
import EquipmentList from "../EquipmentList";
import { useQuery } from '@apollo/client';
import { useStyles } from './styles';
import { useParams } from 'react-router';
import { Typography } from '@material-ui/core';

function EquipmentTab() {
  const classes = useStyles()
  const { equipmentList, setEquipmentList } = useEquipment([]);
  const [uniqueIndexes, setUniqueIndexes] = useState([]);
  const { redeId, serviceId } = useParams();
  const { loading, error, data } = useQuery(GET_FILTERED_EQUIPAMENTOS, {
    variables: {
      token: KEY,
      distritoId: -1,
      tipoEquipamento: -1,
      tipoRede: parseInt(redeId),
      tipoServico: parseInt(serviceId),
      txtPesquisa: "",
    },
  })
  useEffect(() => { 
    if (data) {
      setEquipmentList(data.EquipamentoFilter);
    }
  }, [data])

  useEffect(() => {
    if (data) {
      setUniqueIndexes([...new Set(equipmentList
        .map(eqp => eqp.Nome.charAt(0).toUpperCase())
        .sort((a, b) => a.localeCompare(b))
      )]);
    }
  }, [equipmentList])
  
  if (loading) return (
    <Typography>
      Carregando...
    </Typography>
  );
  if (error) return(
    <Typography>
      Ops! Parece que ocorreu um erro. Tente novamente mais tarde.
    </Typography>
  );
  return (
    <div className={classes.tabContainer}>
      {uniqueIndexes.map((index, pos) => {
        return(
          <div key={pos}>
          <EquipmentIndex
            index={index}
            redeId={redeId}
          />
          <EquipmentList
            equipments={equipmentList.filter(eqp => eqp.Nome.toUpperCase().charAt(0) === index)}
          />
        </div>
        )
      })}
    </div>
  );
}

export default EquipmentTab;